import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from 'Redux/axiosHelper'
import {
  LeagueFoulPayload,
  LeagueFoulUpdatePayload,
  LeagueGoalPayload,
  LeagueGoalUpdatePayload,
  LeagueLogsResp,
  LeagueTimeoutPayload,
  LeagueTimeoutUpdatePayload,
} from 'types/league/leagueLog'

const createLeagueFoul = async (payload: LeagueFoulPayload) => {
  const response = await axiosPost(payload, 'v1/league-fouls')
  return response.data
}
export const useCreateLeagueFoul = () => {
  const queryClient = useQueryClient()
  return useMutation(createLeagueFoul, {
    onSuccess: () => queryClient.invalidateQueries(['league-logs']),
  })
}

const createLeagueTimeout = async (payload: LeagueTimeoutPayload) => {
  const response = await axiosPost(payload, 'v1/league-timeout')
  return response.data
}
export const useCreateLeagueTimeout = () => {
  const queryClient = useQueryClient()
  return useMutation(createLeagueTimeout, {
    onSuccess: () => queryClient.invalidateQueries(['league-logs']),
  })
}

const createLeagueGoal = async (payload: LeagueGoalPayload) => {
  const response = await axiosPost(payload, 'v1/league-player-goals')
  return response.data
}
export const useCreateLeagueGoal = () => {
  const queryClient = useQueryClient()
  return useMutation(createLeagueGoal, {
    onSuccess: () => queryClient.invalidateQueries(['league-logs']),
  })
}

const getLeagueLogs = async (leagueId: string) => {
  const response = await axiosGet(`v1/league-log/${leagueId}`)
  return response.data
}
export const useGetLeagueLogs = (leagueId: string) => {
  return useQuery<LeagueLogsResp>(
    ['league-logs', leagueId],
    () => getLeagueLogs(leagueId),
    { enabled: !!leagueId },
  )
}

// ── Update ────────────────────────────────────────────────────────────────────

const updateLeagueFoul = async ({ id, ...body }: { id: string } & LeagueFoulUpdatePayload) => {
  const response = await axiosPatch(body, `v1/league-fouls/${id}`)
  return response.data
}
export const useUpdateLeagueFoul = () => {
  const queryClient = useQueryClient()
  return useMutation(updateLeagueFoul, {
    onSuccess: () => queryClient.invalidateQueries(['league-logs']),
  })
}

const updateLeagueGoal = async ({ id, ...body }: { id: string } & LeagueGoalUpdatePayload) => {
  const response = await axiosPatch(body, `v1/league-player-goals/${id}`)
  return response.data
}
export const useUpdateLeagueGoal = () => {
  const queryClient = useQueryClient()
  return useMutation(updateLeagueGoal, {
    onSuccess: () => queryClient.invalidateQueries(['league-logs']),
  })
}

const updateLeagueTimeout = async ({ id, ...body }: { id: string } & LeagueTimeoutUpdatePayload) => {
  const response = await axiosPatch(body, `v1/league-timeout/${id}`)
  return response.data
}
export const useUpdateLeagueTimeout = () => {
  const queryClient = useQueryClient()
  return useMutation(updateLeagueTimeout, {
    onSuccess: () => queryClient.invalidateQueries(['league-logs']),
  })
}

// ── Delete ────────────────────────────────────────────────────────────────────

const deleteLeagueFoul = async (id: string) => {
  const response = await axiosDelete(`v1/league-fouls/${id}`)
  return response.data
}
export const useDeleteLeagueFoul = () => {
  const queryClient = useQueryClient()
  return useMutation(deleteLeagueFoul, {
    onSuccess: () => queryClient.invalidateQueries(['league-logs']),
  })
}

const deleteLeagueGoal = async (id: string) => {
  const response = await axiosDelete(`v1/league-player-goals/${id}`)
  return response.data
}
export const useDeleteLeagueGoal = () => {
  const queryClient = useQueryClient()
  return useMutation(deleteLeagueGoal, {
    onSuccess: () => queryClient.invalidateQueries(['league-logs']),
  })
}

const deleteLeagueTimeout = async (id: string) => {
  const response = await axiosDelete(`v1/league-timeout/${id}`)
  return response.data
}
export const useDeleteLeagueTimeout = () => {
  const queryClient = useQueryClient()
  return useMutation(deleteLeagueTimeout, {
    onSuccess: () => queryClient.invalidateQueries(['league-logs']),
  })
}
